var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"gl-status-chip",class:`gl-status-chip--${_vm.type}`},_vm.$listeners),[(_vm.$slots.icon)?_c('div',{staticClass:"gl-status-chip__icon"},[_vm._t("icon")],2):_vm._e(),_c('span',{staticClass:"gl-status-chip__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }